import { useState } from "react"
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"

import { login } from "../../../services/operations/authAPI"

function LoginForm() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [student,setStudent] = useState(true);
  const [libraryId, setLibraryId] = useState('');
  const [email, setEmail] = useState('');


  const [formData, setFormData] = useState({
    password: "",
    accountType:"",
  })

  const [showPassword, setShowPassword] = useState(false)

  const {  password , accountType  } = formData

  const handleOnChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }))
  }

  const handleOnSubmit = (e) => {
    e.preventDefault()
    dispatch(login(email, password, libraryId,accountType,navigate))
  }

  return (
    <form
      onSubmit={handleOnSubmit}
      className="mt-6 flex w-full flex-col gap-y-4 "
    >
     
     {
      student ? ( <label className="w-full">
        <p className="mb-1 text-[0.875rem] leading-[1.375rem]   text-richblack-900 font-bold">
          Student Library ID <sup className="text-pink-200">*</sup>
        </p>
        <input
          required
          type="text"
          name="libraryId"
          value={libraryId}
          onChange={(e)=> setLibraryId(e.target.value)}
          placeholder="Enter libraryId "
          className="form-style w-full"
        />
      </label>)


                :   

                (<label className="w-full">
        <p className="mb-1 text-[0.875rem] leading-[1.375rem]   text-richblack-900 font-bold">
          Email Address <sup className="text-pink-200">*</sup>
        </p>
        <input
          required
          type="text"
          name="email"
          value={email}
          onChange={(e)=> setEmail(e.target.value)}
          placeholder="Enter email address"
          className="form-style w-full"
        />
      </label>)


     }
     
     
      

     

      <label className="relative">
        <p className="mb-1 text-[0.875rem] leading-[1.375rem] text-richblack-900 font-bold">
          Password <sup className="text-pink-200 ">*</sup>
        </p>
        <input
          required
          type={showPassword ? "text" : "password"}
          name="password"
          value={password}
          onChange={handleOnChange}
          placeholder="Enter Password"
          className="form-style w-full !pr-10"
        />
        <span
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute right-3 top-[36px] z-[10] cursor-pointer"
        >
          {showPassword ? (
            <AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF" />
          ) : (
            <AiOutlineEye fontSize={24} fill="#AFB2BF" />
          )}
        </span>
        <Link to="/forgot-password">
          <p className="mt-1 ml-auto max-w-max text-xs text-blue-500">
            Forgot Password ?
          </p>
        </Link>
      </label>
     
     
            <div className="text-xl flex justify-between">
              <label 
              name="accountType"
              htmlFor="student"    
              className="flex gap-x-2 items-center" >
               <p>Student</p>
              
              <input type="radio"   
               name="accountType" 
               value="Student" 
               onChange={(e) => {
                    handleOnChange(e);
                    setStudent(true);
                  }}
                className="font-medium h-6 w-4 text-gray-900 dark:text-gray-300 text-5xl"/>
              </label>
             

              <label 
              htmlFor="Librarian"    
              className="flex gap-x-2 items-center" >
               <p>Librarian</p>
              
           
              
              <input type="radio" 
              name="accountType" 
              value="Librarian"  
              onChange={(e) => {
                    handleOnChange(e);
                    setStudent(false);
                  }}

              className="font-medium h-6 w-4 text-gray-900 dark:text-gray-300 text-5xl"/>
              </label>
            </div>




      <button
        type="submit"
        className="mt-6 rounded-[8px] bg-yellow-50 py-[8px] px-[12px] font-medium text-richblack-900"
      >
        Sign In
      </button>
    </form>
  )
}

export default LoginForm;
